import React, { useEffect, useState } from 'react'
import { MyModal } from '~/components/ui/MyModal'
import styled from 'styled-components'
import {
  CrOrderTypeEnum,
  getOrderInfo,
  getOrderInfoVariables,
  toPay_orderModule_copyrightPay,
} from '~/graphqls/types'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import { GET_ORDER_INFO } from '~/graphqls/gqls'
import { OrderStatus } from '~/configs'
import { message } from 'antd'
import { PayLock } from '~/components/pages/order/PayLock'
import { ScanPayCard } from '~/components/pages/order/ScanPayCard'
import { useStores } from '~/hooks/useStores'
import { observer } from 'mobx-react'
import { OrderSuccessModal } from './OrderSuccessModal'

const StyledPayMain = styled.div`
  display: flex;
  flex-direction: column;
  height: 400px;
  align-items: center;
  justify-content: center;
  text-align: center;
`

// 兜底锁单时间
const LOCK_TIME = 90

export const ScanPayModal: React.FC<{
  payInfo: toPay_orderModule_copyrightPay | undefined
  amount: number
  needLock: boolean // 目前都为true, 用于判断是否显示订单关闭倒计时，后续该字段可能会被废弃掉
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
  icon: string
}> = observer(({ visible, setVisible, payInfo, amount, needLock, icon }) => {
  const [lockTime, setLockTime] = useState(LOCK_TIME)
  const [isInit, setIsInit] = useState(false)
  const [paySuccessVisible, setPaySuccessVisible] = useState(false)

  const { store } = useStores()

  const getOrderInfoQuery = useImperativeQuery<
    getOrderInfo,
    getOrderInfoVariables
  >(GET_ORDER_INFO)

  useEffect(() => {
    if (!visible) return

    getOrderInfoQuery({
      orderNo: payInfo?.orderNo,
    })
      .then(data => {
        const time =
          data?.data?.orderModule?.copyrightOrder?.unpayCloseSecond || LOCK_TIME

        setLockTime(time)
      })
      .finally(() => {
        setIsInit(true)
      })

    // 备注：查询订单状态
    const timer = setInterval(() => {
      if (payInfo?.orderNo) {
        getOrderInfoQuery({
          orderNo: payInfo?.orderNo,
        })
          .then(data => {
            if (
              data?.data?.orderModule?.copyrightOrder?.status ===
                OrderStatus.FINISH &&
              data?.data?.orderModule?.copyrightOrder?.type ===
                CrOrderTypeEnum.BLIND_BOX
            ) {
              store.modal?.setMysteryBoxVisible(true)
              clearInterval(timer)
            } else if (
              data?.data?.orderModule?.copyrightOrder?.status ===
              OrderStatus.FINISH
            ) {
              clearInterval(timer)
              setPaySuccessVisible(true)
            } else if (
              data?.data?.orderModule?.copyrightOrder?.status ===
                OrderStatus.WAIT_DELIVERY ||
              data?.data?.orderModule?.copyrightOrder?.status ===
                OrderStatus.WAIT_RECEIVE
            ) {
              // 这个是特殊情况，对应预售生成的待支付订单
              // OrderSuccessModal可能不兼容，这里先这么处理
              // OrderSuccessModal兼容处理可以参考 presale/OrderSuccessModal, 根据订单类型取不同的对象
              // 这个问题发现的太晚了，在上线前发现的，后续有人有时间做一下吧，统一一下OrderSuccessModal，😁
              clearInterval(timer)
              setTimeout(() => {
                location.reload()
              }, 3000)
            } else if (
              data?.data?.orderModule?.copyrightOrder?.status ===
              OrderStatus.CANCEL
            ) {
              message.destroy()
              message.error('未及时付款，订单已被取消')
              clearInterval(timer)
              setTimeout(() => {
                location.reload()
              }, 3000)
            }
          })
          .catch(() => {})
      }
    }, 3000)

    return () => {
      clearInterval(timer)
    }
  }, [visible, getOrderInfoQuery, payInfo])

  return (
    <MyModal
      visible={visible}
      title="扫码支付"
      onCancel={() => setVisible(false)}
      maskStyle={{
        backgroundColor: 'rgba(0,0,0,0.8)',
      }}
      width={448}
      footer={null}
    >
      <StyledPayMain>
        {needLock && isInit && <PayLock lockTime={lockTime} />}
        <ScanPayCard amount={amount} icon={icon} url={payInfo?.payInfo || ''} />
      </StyledPayMain>
      {paySuccessVisible && (
        <OrderSuccessModal
          visible={paySuccessVisible}
          setVisible={setPaySuccessVisible}
          payInfo={payInfo}
        />
      )}
    </MyModal>
  )
})
